import { BooleanRadioButtonField, Box, FormModal, SpinnerButton, TextField } from '@forgeglobal/design-framework'
import { Field, Form, FormRenderProps } from 'react-final-form'
import { useShareholderDetailsDataQuery, useUpdateShareholderDetailsMutation } from 'graphql/bindings/AdminBindings'

import { MutationResult } from 'react-apollo'
import React from 'react'
import pick from 'lodash/pick'

interface FormShape {
  id: string
  participates_in_secondaries?: boolean
  shareholder_notes?: string
  mutationResult: MutationResult
}

const ShareholderForm: React.FC<FormRenderProps<FormShape>> = ({ handleSubmit, form, values, valid }) => {
  const mutateInProgress = values.mutationResult.called
  return (
    <form onSubmit={handleSubmit}>
      <Field
        name="participates_in_secondaries"
        label="Participates in secondaries"
        component={BooleanRadioButtonField}
      />
      <Field name="shareholder_notes" component={TextField} label="Additional information" fullWidth multiline />
      <Box mt={2}>
        <SpinnerButton
          variant="contained"
          color="primary"
          type="submit"
          fullWidth
          loading={mutateInProgress}
          caption="Save"
        />
      </Box>
    </form>
  )
}

export const AccountShareholderModal: React.FC<{ hideModal: () => void; accountId: string }> = ({
  hideModal,
  accountId,
}) => {
  const { data } = useShareholderDetailsDataQuery({ variables: { id: accountId } })
  const account = data?.account
  const [mutate, mutateResult] = useUpdateShareholderDetailsMutation({
    onCompleted: hideModal,
  })
  const onSubmit = (values: FormShape) => {
    mutate({
      variables: {
        form: {
          ...pick(values, 'id', 'shareholder_notes'),
          has_done_secondaries_before: values.participates_in_secondaries,
        },
      },
    })
  }

  const initialValues: FormShape = {
    id: account?.id ?? '',
    participates_in_secondaries: account?.participates_in_secondaries ?? false,
    shareholder_notes: account?.shareholder_notes ?? '',
    mutationResult: mutateResult,
  }
  return (
    <FormModal open hideModal={hideModal} title="Edit: Account Details">
      <Form<FormShape>
        component={ShareholderForm}
        onSubmit={onSubmit}
        initialValues={{
          ...initialValues,
        }}
      />
    </FormModal>
  )
}
